// libraries
import {uniqueId, isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import 'stylesheets/components/shared-label';

// This label component assumes two children, the label text and the form element
//
// ARIA NOTE:
// Note that even though we don't currently use <label>, we should follow precedence rules
// outlined in: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
// which states that `aria-labelledby` should be prefered and take precedence
// over `aria-label` when the label text is visible. To do this, pass in the
// parameter `autoId` or `id` into this tag and it will pass `aria-labelledby` into
// the child element (which may or may not be supported by all components). If
// the child already has an `aria-labelledby`, then it will tack the id onto the
// end of it in order to handle the case of Multiple Labels (see document link above).
//
// In general `autoId` should be preferred over `id` because it will ensure the ID assigned
// is unique, and will support the `for` parameter
class Label extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    autoId: PropTypes.string, // Provide a root string for a unique ID for label (and supported inputs)
    className: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.node)
      ])
    ).isRequired,
    required: PropTypes.bool,
    noaria: PropTypes.bool
  };

  static defaultProps = {
    style: {}
  };

  UNSAFE_componentWillMount() {
    if (this.props.autoId) {
      this.uniqid = uniqueId(this.props.autoId);
    }
  }

  render() {
    const [text, input] = this.props.children;
    const {required, noaria, className} = this.props;
    const labelProps = {};
    const newInputProps = {};

    if (this.props.id) {
      labelProps.id = this.props.id;
    } else if (this.uniqid) {
      labelProps.id = `${this.uniqid}-label`;
      // TODO: when replace <span> with <label> inject `for=""`
      // labelProps.for = `${this.uniqid}-form`;
      // newInputProps['inputId'] = labelProps.for`;
    }
    if (labelProps.id && !noaria) {
      newInputProps['aria-labelledby'] = (input.props['aria-labelledby'])
        ? `${input.props['aria-labelledby']} ${labelProps.id}`
        : labelProps.id;
    }

    return (
      <div className={classnames('shared-label', className)}>
        {
          !isEmpty(text) &&
          <span className={classnames('shared-label-text', {required})} {...labelProps}>
            {text}
          </span>
        }
        {(isEmpty(newInputProps)) ? input : React.cloneElement(input, newInputProps)}
      </div>
    );
  }
}

export default Label;
